import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import logger from "redux-logger";
import thunk from "redux-thunk";
import {
    quizReducer,
    questionReducer,
    resultReducer
} from "./domains"

const rootReducer = combineReducers({
    questions: questionReducer,
    result: resultReducer,
    quiz: quizReducer
});
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(logger, thunk))
);


export default store;